import { render, staticRenderFns } from "./productDelCenTwo.vue?vue&type=template&id=467a0e88&scoped=true&"
import script from "./productDelCenTwo.vue?vue&type=script&lang=js&"
export * from "./productDelCenTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467a0e88",
  null
  
)

export default component.exports